import { Box, Paper, Typography } from "@mui/material";
import type { ConversationMessage } from "@/types";

interface MessageBubbleProps {
  message: ConversationMessage;
}

/**
 * Plain user / assistant text message. Tool messages have their own
 * dedicated rendering (ToolCallCard / ConfirmationCard) and shouldn't
 * be passed here.
 */
export default function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === "user";
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        my: 0.5,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: "75%",
          px: 1.75,
          py: 1.25,
          bgcolor: isUser ? "primary.main" : "grey.100",
          color: isUser ? "primary.contrastText" : "text.primary",
          borderRadius: 2,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        <Typography variant="body2">{message.content || "(empty)"}</Typography>
      </Paper>
    </Box>
  );
}
